import { useState, useMemo, useCallback } from "react";
import Loader from "../Components/ui/Loader";

export const useLoader = (loaderProps = {}) => {
  const [showLoader, _setShowLoader] = useState(false);

  //stablelise setShowLoader not to be call on rerender
  const setShowLoader = useCallback((value: boolean) => {
    _setShowLoader(value);
  }, []);

  const LoaderComponent = useMemo(() => {
    return showLoader ? <Loader {...loaderProps}/> : null;
  }, [showLoader, loaderProps]);

  return { showLoader, setShowLoader, LoaderComponent };
};
